import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  headerGradient: {
    width: "100%",
    height: "100%",
    flexDirection: "row",
    alignItems: "center",

    shadowColor: "#000",
    shadowOffset: {
      width: 1,
      height: 3,
    },
    shadowOpacity: 1,
    shadowRadius: 3.84,

    elevation: 5,
  },
  headerDrawerView: {
    width: "20%",
    flexDirection: "row",
    // justifyContent: "center",
    alignItems: "center",
  },
  headerTitleView: {
    width: "80%",
    // alignSelf: 'flex-end',
    // justifyContent: 'flex-end',
    // alignItems: "center",
    // borderWidth: 1
  },
  titleView: {
    width: "100%",
    // justifyContent: "center",
    // alignItems: "center",
    paddingLeft: "25%",
  },
  headerTextView: {
    width: "30%",
    justifyContent: "center",
    alignItems: "center",
  },
  headerText: {
    color: "#fff",
    fontSize: 20,
    fontWeight: "bold",
  },

  drawerBtnView: {
    height: 30,
    justifyContent: "center",
    // alignItems: "flex-start",
  },
  userView: {
    paddingLeft: 10,
  },
});

export default styles;
